import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { BUDGET_LINE_ITEMS } from "./apiRoutes";

interface UseGetLineItemProps {
  id: string;
  budgetId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getLineItemById = async (id: string, budgetId: string) =>
  await axiosAuth.get(`${BUDGET_LINE_ITEMS(budgetId)}/${id}`);

const useGetLineItemById = ({
  queryParams,
  budgetId,
  id,
}: UseGetLineItemProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["line-item", id],
    queryFn: () => getLineItemById(id, budgetId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!budgetId && !!id && (queryParams?.enabled ?? true),
  });
};

export default useGetLineItemById;
